let promise = null;

export default function loadGoogleMaps(apiKey) {
  if (promise) return promise;

  if (window.google && window.google.maps) {
    promise = Promise.resolve(window.google.maps);
    return promise;
  }

  promise = new Promise((resolve, reject) => {
    if (!apiKey) {
      reject(new Error("Missing Google Maps API key"));
      return;
    }
    const callbackName = "__beefGmapsInit";
    window[callbackName] = () => {
      resolve(window.google.maps);
      delete window[callbackName];
    };
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=" +
      encodeURIComponent(apiKey) +
      "&loading=async&callback=" +
      callbackName;
    script.async = true;
    script.defer = true;
    script.onerror = () => reject(new Error("Failed to load Google Maps"));
    document.head.appendChild(script);
  });

  return promise;
}
